export default __webpack_public_path__ + "static/media/16.bd884c44.png";